import { render, staticRenderFns } from "./DbHealthTab.vue?vue&type=template&id=205b968c&scoped=true"
import script from "./DbHealthTab.vue?vue&type=script&lang=js"
export * from "./DbHealthTab.vue?vue&type=script&lang=js"
import style0 from "./DbHealthTab.vue?vue&type=style&index=0&id=205b968c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b968c",
  null
  
)

export default component.exports